"use strict";
exports.__esModule = true;
exports.fixEmptyHeaderItems = void 0;
/**
 * This function will mutate the incoming data view and replace headers with empty name with a fallback
 * string. This is so that we can show "(empty)" or similar strings in the UI.
 *
 * @param dataView - view to mutate
 * @param emptyHeaderString - value to use for empty strings
 * @deprecated try to avoid using this function and handle empty headers when displaying them
 * @public
 */
function fixEmptyHeaderItems(dataView, emptyHeaderString) {
    dataView.headerItems.forEach(function (dim) {
        dim.forEach(function (attr) {
            attr.forEach(function (item) {
                var type = Object.keys(item)[0];
                if (["attributeHeaderItem", "measureHeaderItem", "totalHeaderItem"].indexOf(type) >= 0) {
                    item[type].name = item[type].name || emptyHeaderString;
                }
            });
        });
    });
}
exports.fixEmptyHeaderItems = fixEmptyHeaderItems;
//# sourceMappingURL=fixEmptyHeaderItems.js.map